import React from 'react'
import NominalGDPChart from './NominalGDPChart'

export default function NominalGDP() {
  return (
    <>
      <NominalGDPChart />
    </>
  )
}
